import { ReactNode, useMemo } from 'react'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { ThemeMode } from 'models'

// Material-UI paints its own surfaces (Paper, Menu, Dialog, inputs), so it needs
// the mode too; everything else reads the CSS variables in index.css.
const DARK_PALETTE = {
  type: 'dark' as const,
  background: { default: '#15171c', paper: '#1f2228' },
}

export const AppThemeProvider = ({ children }: { children: ReactNode }) => {
  const mode = ThemeMode.use()
  const theme = useMemo(() => createTheme(mode === 'dark' ? { palette: DARK_PALETTE } : {}), [mode])
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
